import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IUserResponse } from "../../Orchestrator/Types/Index";


export async function getUserDetails(showLoader?: boolean): Promise<IApiResponse<IUserResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getUserDetails;
    return await apiRequest<IUserResponse>(endpoint, 'GET', {}, 'none', undefined, undefined, showLoader, false);
}
